



































import {Component, Prop, Vue} from 'vue-property-decorator';
import {SearchResultCompany} from '@/store/models';

@Component
export default class SearchCompanyItem extends Vue {
    @Prop() company: SearchResultCompany | undefined;
}
